import { Injectable } from '@angular/core';
import { ApiUrls } from 'src/app/config/constants';
import { CommonApi } from './api/common.api';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class WalletService {

  constructor(
    private commonService: CommonService,
    private commonApi: CommonApi
  ) { }

  getWalletBalance(userId: string) {
    const payload = { userId };
    return this.commonApi.postData(ApiUrls.walletService, payload);
  }
}
